import axios from 'axios';

export function isNetworkError_Axios(error) {
	return error !== null && typeof error === 'object' && 'response' in error && axios.isAxiosError(error);
}

export function isCancelNetworkError_Axios(payload) {
	return axios.isCancel(payload);
}

export function GET_Axios(url, config) {
	return axios.get(url, config);
}

export function POST_Axios(url, data, config) {
	return axios.post(url, data, config);
}
